import * as React from "react"
import { MatchedComponent } from "src/frontend/components/Shared/Layout/types"
import { EntitiesList } from "src/frontend/components/Shared/Reports/Report/Viewer/Layout/Components/Lists/EntitiesList"

export const SearchResults: React.FC<{ component: MatchedComponent<"entitiesList"> }> = ({
  component,
}) => <EntitiesList component={component} />
